import { BackgroundTaskStatus, isFinishedStatus } from "@/app/models/background-task";
/**
 * The signed-in user's background tasks, shared by the Background tasks panel and the sidebar icon
 * that opens it. Generic: nothing here depends on what a task does.
 */
export class BackgroundTasksState {
    constructor() {
        /** Newest first. */
        this.messages = [];
        this.panelOpen = false;
        /** Tasks the user asked to cancel that have not reported back yet. */
        this.cancellingIds = [];
        /** Finished-with-problems tasks the user has looked at (opened their details, or dismissed them). */
        this.acknowledgedIds = [];
    }
    get hasTasks() {
        return this.messages.length > 0;
    }
    /** Queued or running. */
    get activeCount() {
        return this.messages.filter(m => !isFinishedStatus(m.status)).length;
    }
    /** Finished with problems or failed, and not looked at yet: shown as a red badge. */
    get problemCount() {
        return this.messages.filter(m => isProblem(m) && !this.acknowledgedIds.includes(m.id)).length;
    }
}
export function isProblem(message) {
    return message.status === BackgroundTaskStatus.CompletedWithErrors || message.status === BackgroundTaskStatus.Error;
}
